var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJudgeHammer2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.83,
    height: 21.78,
    viewBox: "0 0 17.83 21.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "judge-hammer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3,1.2a.37.37,0,0,1,.3.1,1.85,1.85,0,0,1,1.2.7c2,2.1,4.1,4.1,6.1,6.2a2.35,2.35,0,0,1,0,3.3l-2.6,2.6a2.35,2.35,0,0,1-3.3,0l-1.7-1.7-1.2,1.2L6.7,18a2.05,2.05,0,0,1-2.9.1,1.93,1.93,0,0,1-.1-2.8l.4-.4,4.8-4.8a4.62,4.62,0,0,0,.7-.7,4.06,4.06,0,0,1-1-.9l-.7-.7a2.23,2.23,0,0,1,0-3.2c.9-.9,1.8-1.8,2.6-2.7a2.39,2.39,0,0,1,1.3-.7h.5Zm1.6,2.9L10.2,7.8l3.9,3.9L17.8,8C16.5,6.7,15.1,5.4,13.9,4.1ZM5.5,17c.1-.1.2-.1.4-.2,1.7-1.7,3.4-3.3,5-5l.1-.1a.48.48,0,0,0,0-.7.56.56,0,0,0-.9,0l-5,5-.1.1a1.27,1.27,0,0,0-.1.6A.6.6,0,0,0,5.5,17ZM12.8,3a.82.82,0,0,0-1.2-.1L9,5.5A.79.79,0,0,0,9,6.8C10.2,5.5,11.5,4.3,12.8,3Zm2.3,9.9a.75.75,0,0,0,1.2,0l2-2,.6-.6a.75.75,0,0,0-.1-1.2C17.6,10.4,16.3,11.6,15.1,12.9Z",
    transform: "translate(-3.02 -1.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22.7H5.5a2,2,0,0,1-2.1-1.8,2.14,2.14,0,0,1,1.8-2.4H18.5a2,2,0,0,1,2,1.1,2.07,2.07,0,0,1-1.9,3C16.4,22.8,14.2,22.7,12,22.7ZM12,20H5.3a.65.65,0,0,0-.6.6c0,.4.3.6.7.6H18.5a.5.5,0,0,0,.5-.6.58.58,0,0,0-.6-.6H12Z",
    transform: "translate(-3.02 -1.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-3.02 -1.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-3.02 -1.07)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudgeHammer2);
export default __webpack_public_path__ + "static/media/judge-hammer2.a288e66c5bead8f339494ff47abc47b4.svg";
export { ForwardRef as ReactComponent };